import type { SRT_Column, SRT_Row, SRT_RowData } from '../types'
import type { Viewport, ViewportDimmensions } from './types'

import { getColumnBoundaries, getRowsVisibleBoundary } from './utils'

export const getViewport = <T extends SRT_RowData>(
	state: ViewportDimmensions & {
		skipItems: [number, number]
	},
	getters: {
		bodyRows: SRT_Row<T>[]
		columns: SRT_Column<T>[]
		getRowSize: (row?: SRT_Row<T>) => number
		getColSize:
			| ((column: SRT_Column<T>) => number)
			| ((column?: SRT_Column<T>) => undefined)
	}
): Viewport => {
	const { top, left, width, height, skipItems } = state
	const { bodyRows, columns, getRowSize, getColSize } = getters

	// Temporary hardcoded values
	const loadedRowsStart = 0
	const isDataRemote = false

	return {
		rows: getRowsVisibleBoundary<T>(
			bodyRows,
			top,
			height,
			getRowSize,
			skipItems,
			loadedRowsStart,
			isDataRemote
		),
		columns: getColumnBoundaries(columns, left, width, getColSize),
	}
}
